<template>
  <div class="email-app-details">
    <!-- Email Header -->
    <div class="email-detail-header">
      <!-- Header: Left -->
      <div
        class="email-header-left w-100 d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center">
          <span class="go-back mr-1">
            <feather-icon
              :icon="
                $store.state.appConfig.isRTL
                  ? 'ChevronRightIcon'
                  : 'ChevronLeftIcon'
              "
              size="20"
              class="align-bottom"
              @click="$emit('close-email-view')"
            />
          </span>
          <h4 class="email-subject mb-0">{{ emailViewData.title }}</h4>
        </div>
        <b-button
          @click="printMessage"
          class="btn-icon print-btn rounded-circle"
          variant="flat-secondary"
        >
          <feather-icon icon="PrinterIcon" size="18" />
        </b-button>
      </div>

      <!-- Header: Right -->
      <!-- <div class="email-header-right">
        <b-button
          title="رد"
          v-b-tooltip.hover.bottom.v-secondary
          class="btn-icon rounded-circle"
          variant="outline-secondary"
        >
          <feather-icon icon="MessageSquareIcon" />
        </b-button>
      </div> -->
    </div>

    <!-- Email Details -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="email-scroll-area scroll-area"
    >
      <!-- Label Row -->
      <!-- <b-row>
        <b-col cols="12">
          <div class="email-label">
            <b-badge
              v-for="label in emailViewData.labels"
              :key="label"
              pill
              class="text-capitalize mr-50"
              :variant="`light-${resolveLabelColor(label)}`"
            >
              {{ label }}
            </b-badge>
          </div>
        </b-col>
      </b-row> -->

      <!-- Action: Show Earlier Message -->
      <!-- <b-row
        v-if="
          !showWholeThread &&
          emailViewData.replies &&
          emailViewData.replies.length
        "
        class="mb-1"
      >
        <b-col cols="12">
          <b-link class="font-weight-bold" @click="showWholeThread = true">
            View {{ emailViewData.replies.length }} Earlier Message{{
              emailViewData.replies.length > 1 ? "s" : ""
            }}
          </b-link>
        </b-col>
      </b-row> -->

      <!-- Email Thread -->
      <b-row class="mt-2">
        <b-col cols="12">
          <email-message-card :message="emailViewData" />
        </b-col>
      </b-row>

      <!-- Earlier Email Messages -->
      <template
        v-if="emailViewData.replies && emailViewData.replies.length > 0"
      >
        <b-row v-for="threadMail in emailViewData.replies" :key="threadMail.id">
          <b-col cols="12">
            <email-message-card :message="threadMail" />
          </b-col>
        </b-row>
      </template>
      <!-- Email Actions: Reply or Forward -->
      <b-row>
        <b-col cols="12">
          <b-card>
            <div class="d-flex justify-content-between">
              <h5 class="mb-0 reply-row">
                اضغط هنا
                <b-link class="reply-row" @click="$emit('toggle-reply-modal')"
                  >للرد على المراسلة</b-link
                >
              </h5>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import {
  BDropdown,
  VBTooltip,
  BButton,
  BDropdownItem,
  BRow,
  BCol,
  BBadge,
  BCard,
  BLink,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ref, watch } from "@vue/composition-api";
import useEmail from "../useEmail";
import EmailMessageCard from "./EmailMessageCard.vue";

export default {
  components: {
    // BSV
    BDropdown,
    BButton,
    BDropdownItem,
    BRow,
    BCol,
    BBadge,
    BCard,
    BLink,

    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    EmailMessageCard,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    emailViewData: {
      type: Object,
      required: true,
    },
    opendedEmailMeta: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { resolveLabelColor } = useEmail();

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };

    const showWholeThread = ref(false);

    watch(
      () => props.emailViewData.id,
      () => {
        showWholeThread.value = false;
      }
    );

    const printMessage = () => {
      print();
    };

    return {
      // UI
      perfectScrollbarSettings,
      showWholeThread,

      // useEmail
      printMessage,
      resolveLabelColor,
    };
  },
};
</script>

<style></style>
